<template>
    <div class="d-flex flex-row">
        <div class="add-btn position-relative">
            <b-dropdown dropright :text="label" variant="light" class="m-1" boundary="window">
                <template v-for="item of localeConfig">
                    <b-dropdown-item :key="item.key" @click="addProperty(item)">{{ item.label }}</b-dropdown-item>
                </template>
            </b-dropdown>
            <b-avatar v-if="!isRoot" size="12" variant="danger" icon="x-lg" button class="avatar-cover"
                      @click="$emit('delete')"></b-avatar>
        </div>
        <div class="d-flex flex-column col">
            <template v-for="key of Object.keys(currentValue)">
                <div :key="key" class="d-flex flex-row w-100" v-if="getConfig(key)!==undefined">
                    <json-input-object v-if="typeIsObject(getConfig(key).type)"
                                       class="w-100 mb-1"
                                       :config="getConfig(key).children"
                                       :label="getConfig(key).label"
                                       :value.sync="currentValue[key]"
                                       @delete="whenDelete(key)"></json-input-object>
                    <json-input-array v-else-if="typeIsArray(getConfig(key).type)"
                                      class="w-100 mb-1"
                                      :config="getConfig(key).children"
                                      :label="getConfig(key).label"
                                      :value.sync="currentValue[key]"
                                      @delete="whenDelete(key)"></json-input-array>
                    <mini-form-input v-else
                                     class="w-100 mb-1"
                                     :value.sync="currentValue[key]"
                                     :config="getConfig(key)"
                                     :width-px="[100,210]"
                                     horizontal
                                     @delete="whenDelete(key)"></mini-form-input>
                </div>
            </template>
        </div>

    </div>
</template>

<script>
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniFormInput from "@/views/report/jsonEdit/MiniFormInput";
import JsonInputArray from "@/views/report/jsonEdit/JsonInputArray";

export default {
    name: "JsonInputObject",
    components: {JsonInputArray, MiniFormInput},
    mixins: [emCommonUtilMixin],
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            require: true
        },
        config: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Select',
        },
        isRoot: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localeConfig: [],
            currentValue: {}
        }
    },
    watch: {
        currentValue: {
            handler() {
                this.$emit('update:value', this.currentValue);
            },
            deep: true,
        },
        value: {
            handler() {
                this.currentValue = this.value;
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.initializedConfig();
    },
    methods: {
        initializedConfig() {
            this.localeConfig = this.deepCopyObj(this.config);
        },
        addProperty(item) {
            this.$set(this.currentValue, item.key, '');
        },
        getConfig(key) {
            for (let item of this.localeConfig) {
                if (item.key === key) {
                    return item;
                }
            }
            return undefined;
        },
        typeIsObject(type) {
            return type === 'object';
        },
        typeIsArray(type) {
            return type === 'array';
        },
        whenDelete(key) {
            this.$delete(this.currentValue, key);
        },
    }
}
</script>

<style scoped>
.add-btn {
    height: max-content;
}

.add-btn:hover .avatar-cover {
    opacity: 1;
}

.avatar-cover {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 99;
    transition: opacity ease-out .3s;
}

.avatar-cover:hover {
    opacity: 1;
}
</style>